<route>
{
  "meta": {
    "permission": [
      "inventory.view_movement"
    ]
  }
}
</route>

<template>
  <i-table
    :title="$tc('physicalDiscrepancy', 2)"
    :headers="headers"
    app="inventory.movement"
    api="inventory"
    :opt="{
      company_id: company ? company.pk : null,
      report_type: 'discrepancy'
    }"
    dontRemove
    dontCreate
    dontEdit
  >
    <template v-slot:item.system_quantity="{ item }">
      {{
        (
          parseFloat(item.quantity || 0) -
          parseFloat(item.discrepancy_total || 0)
        ).toFixed(2)
      }}
    </template>
    <template v-slot:extraToolbar>
      <v-divider class="mx-4" inset vertical></v-divider>
      <i-btn
        text
        :small="$vuetify.breakpoint.smAndDown"
        icon="fa-file-excel"
        :title="$t('download', { value: $tc('physicalDiscrepancy', 2) })"
        color="text-dark"
        @click="getInventoryExcel()"
      />
      <i-btn
        text
        :small="$vuetify.breakpoint.smAndDown"
        icon="fa-file-pdf"
        :title="$t('download', { value: $tc('physicalDiscrepancy', 2) })"
        color="text-dark"
        @click="getInventoryPdf()"
      />
    </template>
  </i-table>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      company: 'company/getCompanyData'
    }),
    headers() {
      return [
        {
          text: this.$t('code'),
          value: 'internalCode'
        },
        {
          text: this.$tc('product', 1),
          value: 'name'
        },
        {
          text: 'Cantidad en Sistema',
          value: 'system_quantity',
          align: 'right'
        },
        {
          text: this.$tc('discrepancy', 1),
          value: 'discrepancy_total',
          align: 'right'
        },
        {
          text: 'Cantidad Física',
          value: 'quantity',
          align: 'right'
        }
      ]
    }
  },
  methods: {
    getInventoryPdf() {
      this.downloadFile({
        api: 'inventory',
        method: 'pdf',
        filename: this.$tc('physicalDiscrepancy', 2),
        action: 'download',
        ext: 'pdf',
        opt: {
          pk: this.company.pk,
          params: '?report_type=discrepancy'
        }
      })
    },
    getInventoryExcel() {
      this.downloadFile({
        api: 'inventory',
        method: 'excel',
        filename: this.$tc('physicalDiscrepancy', 2),
        action: 'download',
        ext: 'xlsx',
        opt: {
          pk: this.company.pk,
          params: '?report_type=discrepancy'
        }
      })
    }
  }
}
</script>
